import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'
import { Capacitor } from '@capacitor/core'
import ToastsStore from '@/store/toasts'

export const cameraTakePhoto = async (
  source: 'camera' | 'gallery' | 'prompt',
  params?: {
    width?: number,
    height?: number,
  }
) => {
  const toastsStore = ToastsStore()

  try {
    let action = CameraSource.Photos
  
    if (Capacitor.isNativePlatform()) {
      const permissions = await Camera.checkPermissions()

      if (source === 'camera') {
        if (permissions.camera !== 'granted' && permissions.camera !== 'limited') {
          const result = await Camera.requestPermissions()

          if (result.camera !== 'granted' && result.camera !== 'limited') {
            toastsStore.add({
              content: useNuxtApp().$i18n.t('errors.perm'),
              type: 'failure'
            })

            throw new Error('Permission denied')
          }
        }

        action = CameraSource.Camera
      } else if (source === 'gallery') {
        if (permissions.photos !== 'granted' && permissions.photos !== 'limited') {
          const result = await Camera.requestPermissions()

          if (result.photos !== 'granted' && result.photos !== 'limited') {
            toastsStore.add({
              content: useNuxtApp().$i18n.t('errors.perm'),
              type: 'failure'
            })

            throw new Error('Permission denied')
          }
        }

        action = CameraSource.Photos
      } else if (source === 'prompt') {
        if ((permissions.photos !== 'granted' && permissions.photos !== 'limited' ) || (permissions.camera !== 'granted' && permissions.camera !== 'limited')) {
          const result = await Camera.requestPermissions()

          if ((result.photos !== 'granted' && result.photos !== 'limited') || (result.camera !== 'granted' && result.camera !== 'limited')) {
            if (result.photos === 'granted' || result.camera === 'limited') {
              action = CameraSource.Camera
            } else {
              toastsStore.add({
                content: useNuxtApp().$i18n.t('errors.perm'),
                type: 'failure'
              })
              
              throw new Error('Permission denied')
            }
          } else {
            action = CameraSource.Prompt
          }
        }
      }
    }

    const result = await Camera.getPhoto({
      quality: 100,
      allowEditing: false,

      source: action,
      resultType: CameraResultType.Uri,
      
      width: params?.width,
      height: params?.height,
      correctOrientation: true,
      
      promptLabelHeader: useNuxtApp().$i18n.t('components.Camera.title'),
      promptLabelCancel: useNuxtApp().$i18n.t('components.Camera.cancel'),
      promptLabelPhoto: useNuxtApp().$i18n.t('components.Camera.gallery'),
      promptLabelPicture: useNuxtApp().$i18n.t('components.Camera.camera')
    })

    return result
  } catch (e) {
    if ((e as any).message !== 'User cancelled photos app') {
      console.error(e)

      toastsStore.add({
        content: useNuxtApp().$i18n.t('errors.perm'),
        type: 'failure'
      })
    }

    return null
  }
}